import { useNavigate } from "react-router-dom";
import Box from "../components/Box/Box";
import Progressbar from "../components/Progressbar/Progressbar";

export default function Intro() {
    const navigate = useNavigate();

    return (
        <div>
            <div className="flex justify-end items-center">
                <div className="xs:w-52 md:w-full max-w-xs">
                    <Progressbar percentage={"0"} />
                </div>
            </div>
            <Box>
                <h2>Innan du börjar din överklagan</h2>

                <p>
                    Använd det här formuläret för att överklaga en tilläggsavgift.
                </p>

                <ul>
                    <li>
                        Om du är under 18 år behöver du fylla i en mejladress till en vårdnadshavare, god man eller ett ombud som vi kan kontakta.                    </li>
                    <li>
                        Om du har en god man eller ett ombud behöver du fylla i den personens mejladress så att vi kan kontakta personen.
                    </li>
                </ul>

                <p>
                    Undrar du över något medan du fyller i formuläret kan du alltid kontakta vår kundservice på <a href="tel:0771211010">0771 – 21 10 10</a>.
                </p>

            </Box>

            <div className="flex justify-center">
                <div className="w-full text-right">
                    <button
                        onClick={() => navigate("/tillaggsavgiftsnummer")}
                        className="btn primary"
                        type="submit"
                    >
                        Överklaga tilläggsavgift
                    </button>
                </div>
            </div>
        </div>
    );
}
